var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContract = function SvgContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 15,
    fill: "url(#contract_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5A1.5 1.5 0 0 1 12 7h5.172a1.5 1.5 0 0 1 1.06.44l2.829 2.828a1.5 1.5 0 0 1 .439 1.06V23.5A1.5 1.5 0 0 1 20 25h-8a1.5 1.5 0 0 1-1.5-1.5v-15Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5v3a1 1 0 0 0 1 1h3",
    stroke: "#5D87EB",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15h5M13.5 18h5M13.5 21h3",
    stroke: "#5D87EB",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "contract_svg__a",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D87EB"
  })))));
};

export default SvgContract;